import type { MatterType, Treatment } from "@/lib/mockData";

const badgeStyles: Record<string, string> = {
  litigation: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  transactional: "bg-blue-50 text-blue-700 border border-blue-200",
  good_law: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  distinguished: "bg-amber-50 text-amber-700 border border-amber-200",
  caution: "bg-rose-50 text-rose-700 border border-rose-200",
  overruled: "bg-rose-50 text-rose-700 border border-rose-200",
};

const treatmentLabels: Record<Treatment, string> = {
  good_law: "Good law",
  distinguished: "Distinguished",
  caution: "Caution",
  overruled: "Overruled",
};

export function TreatmentBadge({ type }: { type: Treatment }) {
  return (
    <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${badgeStyles[type]}`}>
      {treatmentLabels[type]}
    </span>
  );
}

export function MatterBadge({ type }: { type: MatterType }) {
  const label = type === "litigation" ? "Litigation" : "Transactional";
  const dot = type === "litigation" ? "bg-emerald-500" : "bg-blue-500";
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-medium px-2 py-0.5 rounded-full ${badgeStyles[type]}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />
      {label}
    </span>
  );
}
